<template>
  <div>
    <v-row>
      <v-col md="4">
        <ModuleHeader>Tarifario</ModuleHeader>
        <v-autocomplete
          v-model="tarifarioSelected"
          label="Seleccione un tarifario"
          outlined
          dense
          :items="tarifarios"
          item-value="value"
          item-text="text"
          hide-details
        ></v-autocomplete>
      </v-col>
      <v-col md="8">
        <ModuleHeader>Temporada</ModuleHeader>
        <v-select
          outlined
          dense
          class="mb-n2"
          label="Seleccione una temporada"
          :items="temporadas"
          v-model="temporadaSelected"
          item-value="id"
          item-text="NombreCompleto"
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-btn @click="getTarifas()" class="mb-2 mx-2 primary">Buscar</v-btn>
      <v-btn class="mr-2" color="green" dark @click="exportExcel">
        <v-icon>mdi-file-excel-box</v-icon>
        Exportar a Excel
      </v-btn>

      <!-- <v-btn color="green" dark class="mr-2">
        <v-icon>mdi-file-excel-box</v-icon>
        Exportar a Excel
        <download-excel type="xls" name="Reporte Existencias" :data="excelData">
        </download-excel>
      </v-btn> -->
      <v-btn @click="generatePdf()" color="red" dark> Generar pdf </v-btn>
    </v-row>
    <v-simple-table>
      <thead>
        <tr>
          <th>Tipo de juego</th>
          <th>Horario</th>
          <th>Nombre de Horario</th>
          <th>Tarifario</th>
          <th>Precio</th>
        </tr>
      </thead>
      <tbody v-if="tarifas.length > 0">
        <template v-for="(tarifa, index) in parsedTarifas">
          <tr
            v-if="tarifa.header == true"
            :key="index"
            style="background: #2185d03b"
          >
            <td
              colspan="2"
              class="text-center"
              style="height: min-content; font-weight: bold"
            >
              Categoría: {{ tarifa.nombreCategoria }}
            </td>
            <td
              colspan="1"
              class="text-center"
              style="height: min-content; font-weight: bold"
            >
              Departamento: {{ tarifa.nombreDepartamento }}
            </td>
            <td
              colspan="2"
              class="text-center"
              style="height: min-content; font-weight: bold"
            >
              Temporada: {{ tarifa.temporadaCompleta }}
            </td>
          </tr>
          <tr v-if="tarifa.header == false" :key="index">
            <td>{{ tarifa.tipoJuego }}</td>
            <td>{{ tarifa.horario }}</td>
            <td>{{ tarifa.nombreHorario }}</td>
            <td>{{ tarifa.nombreTarifario }}</td>
            <td>{{ tarifa.precio }}</td>
          </tr>
        </template>
      </tbody>
      <tbody v-else>
        <h5>
          {{
            userHasSearched
              ? " No hay tarifas disponibles"
              : "Pulse el botón de buscar"
          }}
        </h5>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import TarifasClass from "../../clases/Tarifa.js";
import moment from "moment";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import ReporteTarifas from "../../clases/PdfMakers/ReporteTarifas.js";
import TarifasExcelExporter from "../../clases/ExcelMaker/ReporteTarifasExcel.js";

export default {
  name: "ReporteTarifas",
  data() {
    return {
      tarifas: [],
      parsedTarifas: [],
      mainDepartamento: "",
      temporadaSelected: "All",
      temporadas: [],
      tarifarioSelected: "ALL",
      tarifarios: [],
      subcategorias: [],
      horarios: [],
      tiposJuego: [],
      hoyos: "",
      userHasSearched: false,
    };
  },
  methods: {
    exportExcel() {
      TarifasExcelExporter.exportReporteTarifas(
        this.parsedTarifas,
        "Reporte Tarifas"
      )
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "ReporteTarifas.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => console.error("Error exportando Excel:", err));
    },
    async generatePdf() {
      let mainData = {
        TITLE: "Reporte de Tarifas",
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        data: this.parsedTarifas,
      };
      let docData = ReporteTarifas.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    async getTiposJuego() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/" + this.mainDepartamento + "/Modalidades"
        );
      let arrayTipos = Object.entries(data.val());
      arrayTipos.forEach((element) => {
        this.tiposJuego.push({
          id: element[0],
          codigo: element[1]["Codigo"],
          nombre: element[1]["Nombre"],
        });
      });
    },
    /** Hay que tener en cuenta que son los horarios de GOLF */
    async getHorarios() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/Golf/Horarios"
        );
      if (!data.exists()) {
        return false;
      }
      let arrayHorarios = Object.entries(data.val());
      arrayHorarios.forEach((element) => {
        this.horarios.push({ id: element[0], ...element[1] });
      });
    },

    async getTemporadas() {
      /* obtiene el listado de temporadas activas en el sistema  */
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/" + this.mainDepartamento + "/Temporadas"
        );
      if (!data.exists()) {
        return false;
      }
      let arrayTarifas = Object.entries(data.val());
      const sortedTarifas = arrayTarifas
        .slice()
        .sort(
          (a, b) => new Date(b[1].FechaInicio) - new Date(a[1].FechaInicio)
        );
      this.temporadas.push({
        id: "ALL",
        NombreCompleto: "Todos",
      });
      sortedTarifas.forEach((element) => {
        this.temporadas.push({
          id: element[0],
          NombreCompleto:
            element[1].Nombre +
            " : " +
            element[1].FechaInicio +
            " - " +
            element[1].FechaTermino,
          ...element[1],
        });
      });
      this.temporadaSelected = this.temporadas[0].id;
    },
    async getComboTarifarios() {
      /* obtiene el listado de tarifas para armado del comboBox */
      let tarifarios = await TarifasClass.getMixTarifasCombo(
        this.mainDepartamento
      );
      this.tarifarios.push({
        value: "ALL",
        text: "Todos",
      });

      tarifarios.forEach((element) => {
        this.tarifarios.push({
          value: element.Id,
          text: element.Nombre,
        });
      });

      this.tarifarioSelected = this.tarifarios[0].value;
    },

    async getSubcategoria() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/" + this.mainDepartamento + "/SubCategorias"
        );
      if (!data.exists()) {
        return false;
      }
      let arrayHoteles = Object.entries(data.val());

      arrayHoteles.forEach((element) => {
        this.$pgsHelper.log(element);
        this.subcategorias.push({
          id: element[0],
          key: element[0],
          text: element[1].Nombre,
          value: element[0],
          ...element[1],
        });
      });
    },

    async getTarifas() {
      this.userHasSearched = true;
      this.tarifas = [];

      let dataTarifas = await TarifasClass.getTarifasParsebyTemp(
        this.horarios,
        this.temporadas,
        this.tiposJuego
      );

      dataTarifas.forEach((tarifa) => {
        tarifa.SubcategoriaData = [];
        tarifa.Subcategoria.forEach((subc) => {
          tarifa.SubcategoriaData.push(
            this.$pgsHelper.getById(this.subcategorias, "id", subc)
          );
        });

        let tarifarioName = this.$pgsHelper.getById(
          this?.tarifarios,
          "value",
          tarifa.Tarifario
        );

        tarifa.TarifarioName = tarifarioName.text;
      });

      const tarifarioTextSelected = this.$pgsHelper.getById(
        this.tarifarios,
        "value",
        this.tarifarioSelected
      );

      let tarifasMatched = [];

      if (this.tarifarioSelected != "ALL" && this.temporadaSelected != "ALL") {
        let tarifasMatchedByTarifario = this.$pgsHelper.filterBy(
          dataTarifas,
          "TarifarioName",
          tarifarioTextSelected.text,
          true
        );
        tarifasMatched = this.$pgsHelper.filterBy(
          tarifasMatchedByTarifario,
          "Temporada",
          this.temporadaSelected
        );

        this.tarifas = tarifasMatched;
      } else if (this.temporadaSelected != "ALL") {
        tarifasMatched = this.$pgsHelper.filterBy(
          dataTarifas,
          "Temporada",
          this.temporadaSelected
        );
        this.tarifas = tarifasMatched;
      } else if (this.tarifarioSelected != "ALL") {
        tarifasMatched = this.$pgsHelper.filterBy(
          dataTarifas,
          "TarifarioName",
          tarifarioTextSelected.text,
          true
        );

        this.tarifas = tarifasMatched;
      } else {
        this.tarifas = dataTarifas;
      }
      // Hace el sort por tarifarios
      this.tarifas.sort((a, b) => {
        if (a.TarifarioName < b.TarifarioName) {
          return -1;
        }
        if (a.TarifarioName > b.TarifarioName) {
          return 1;
        }
        return 0;
      });
      this.parseTarifas();
    },
    parseTarifas() {
      let tarifaData = [];
      this.parsedTarifas = [];
      tarifaData = this.tarifas;

      tarifaData.forEach((tarifa) => {
        this.parsedTarifas.push({
          nombreCategoria:
            tarifa?.SubcategoriaData[0]?.Nombre || "No hay información",
          nombreDepartamento: tarifa?.Departamento || "No hay información",
          temporadaCompleta:
            tarifa.data?.NombreCompleto || "No hay información",
          header: true,
        });
        tarifa.arrayPrecios.forEach((precios) => {
          precios.horarios.forEach((horarios) => {
            let horario = "";

            if (horarios.data.HoraInicio && horarios.data.HoraTermino) {
              horario =
                horarios.data.HoraInicio + " - " + horarios.data.HoraTermino;
            } else {
              horario = "No hay información";
            }

            this.parsedTarifas.push({
              header: false,
              categoria:
                tarifa?.SubcategoriaData[0]?.Nombre || "No hay información",
              nombreTarifario: tarifa?.TarifarioName || "No hay información",
              tipoJuego: precios.data?.nombre || "No hay información",
              precio:
                horarios.PcoVen + " " + horarios.Moneda || "No hay información",
              horario: horario,
              nombreHorario: horarios.data.Nombre || "No hay información",
            });
          });
        });
      });
    },
  },
  computed: {
    excelData() {
      let ExcelData = [];
      let DataProd = {};
      this.parsedTarifas.forEach((element) => {
        if (element.header == false) {
          DataProd = {
            Horario: element.horario,
            TipoDeJuego: element.tipoJuego,
            Categoria: element.categoria,
            NombreDeHorario: element.nombreHorario,
            Tarifario: element.nombreTarifario,
            Precio: element.precio,
          };
          ExcelData.push(this.$pgsHelper.cloneObj(DataProd));
        }
      });
      console.log(ExcelData);
      return ExcelData;
    },
  },
  created() {
    this.mainDepartamento = localStorage.getItem("selectedDepartment");
    this.getTiposJuego();
    this.getHorarios();
    this.getTemporadas();
    this.getComboTarifarios();
    this.getSubcategoria();
  },
};
</script>
